import { render } from "./TipTapTextArea.vue?vue&type=template&id=3be3d470&scoped=true&ts=true"
import script from "./TipTapTextArea.vue?vue&type=script&lang=ts"
export * from "./TipTapTextArea.vue?vue&type=script&lang=ts"

import "./TipTapTextArea.vue?vue&type=style&index=0&id=3be3d470&lang=scss&scoped=true"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be3d470"]])

export default __exports__